import { type FC } from 'react';

import { type IconProps } from './types';

export const LocationV4Icon: FC<IconProps> = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 11.0625C4.5 5.73833 9.02638 1.5 14.5 1.5C19.9736 1.5 24.5 5.73833 24.5 11.0625C24.5 14.064 22.8771 17.7776 21.0994 20.9874C19.295 24.2453 17.217 27.1804 16.1026 28.6854C15.9187 28.9368 15.6783 29.1414 15.4007 29.2827C15.1217 29.4247 14.813 29.4987 14.5 29.4987C14.187 29.4987 13.8783 29.4247 13.5993 29.2827C13.3217 29.1414 13.0812 28.9367 12.8973 28.6853C11.783 27.1798 9.70497 24.2435 7.90058 20.9852C6.12292 17.7752 4.5 14.0619 4.5 11.0625ZM14.5 3.5C10.0361 3.5 6.5 6.93542 6.5 11.0625C6.5 13.5006 7.87708 16.8145 9.65021 20.0163C11.3918 23.1613 13.4091 26.0146 14.5 27.4889C15.5908 26.0153 17.6082 23.163 19.3498 20.0184C21.1229 16.8171 22.5 13.5028 22.5 11.0625C22.5 6.93542 18.9639 3.5 14.5 3.5Z"
        fill="#00FFBB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 9.5C13.3954 9.5 12.5 10.3954 12.5 11.5C12.5 12.6046 13.3954 13.5 14.5 13.5C15.6046 13.5 16.5 12.6046 16.5 11.5C16.5 10.3954 15.6046 9.5 14.5 9.5ZM10.5 11.5C10.5 9.29086 12.2909 7.5 14.5 7.5C16.7091 7.5 18.5 9.29086 18.5 11.5C18.5 13.7091 16.7091 15.5 14.5 15.5C12.2909 15.5 10.5 13.7091 10.5 11.5Z"
        fill="#00FFBB"
      />
    </svg>
  );
};
